module.exports = __webpack_public_path__ + "img/slider.fc8d43ef.svg";